import { render, staticRenderFns } from "./ContractFormDialog.vue?vue&type=template&id=0845893e&scoped=true&"
import script from "./ContractFormDialog.vue?vue&type=script&lang=js&"
export * from "./ContractFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContractFormDialog.vue?vue&type=style&index=0&id=0845893e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845893e",
  null
  
)

export default component.exports